import { ConditionMetricCounts } from 'services/conditions/useConditionMetrics';

type ConditionMetricValue = {
  text: string;
  value: number;
  color: string;
};

export default function getConditionMetricsArray(
  conditionMetric: ConditionMetricCounts,
): ConditionMetricValue[] {
  const { support, improve, okay, good } = conditionMetric;
  return [
    { text: 'needs support', value: support, color: 'red' },
    { text: 'needs improving', value: improve, color: 'orange' },
    { text: okay > 1 ? 'are okay' : 'is okay', value: okay, color: 'grey' },
    { text: good > 1 ? 'are great' : 'is great', value: good, color: 'green' },
  ];
}
